import { render } from "./brandIcons.vue?vue&type=template&id=23b3f8f9&scoped=true"
import script from "./brandIcons.vue?vue&type=script&lang=js"
export * from "./brandIcons.vue?vue&type=script&lang=js"

import "./brandIcons.vue?vue&type=style&index=0&id=23b3f8f9&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b3f8f9"]])

export default __exports__